import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginScreen from './screens/LoginScreen';
import CreateAccountScreen from './screens/CreateAccountScreen';
import VerifyEmailScreen from './screens/VerifyEmailScreen';
import ForgotPasswordScreen from './screens/ForgotPasswordScreen';
import ResetPasswordScreen from './screens/ResetPasswordScreen';
import MvirsLoginScreen from './screens/MvirsLoginScreen';
import InspectionHistoryScreen from './screens/InspectionHistoryScreen';
import InspectionDetailScreen from './screens/InspectionDetailScreen';
import CustomerDetailScreen from './screens/CustomerDetailScreen';
import InsuranceDetailScreen from './screens/InsuranceDetailScreen';

// Requires web account login
const WebRoute = ({ children }) => {
  const { webUser, sessionLoading } = useAuth();
  if (sessionLoading) return <LoadingScreen />;
  return webUser ? children : <Navigate to="/login" />;
};

// Requires both web + MVIRS login
const PrivateRoute = ({ children }) => {
  const { webUser, mvirsUser, sessionLoading } = useAuth();
  if (sessionLoading) return <LoadingScreen />;
  if (!webUser) return <Navigate to="/login" />;
  if (!mvirsUser) return <Navigate to="/mvirs-login" />;
  return children;
};

const LoadingScreen = () => (
  <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f2f5' }}>
    <div style={{ textAlign: 'center' }}>
      <div style={{ width: 40, height: 40, border: '4px solid #e0e0e0', borderTop: '4px solid #007AFF', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
      <p style={{ color: '#666', fontSize: 16 }}>Loading...</p>
    </div>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/create-account" element={<CreateAccountScreen />} />
          <Route path="/verify-email" element={<VerifyEmailScreen />} />
          <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
          <Route path="/reset-password" element={<ResetPasswordScreen />} />

          {/* Web account required */}
          <Route path="/mvirs-login" element={
            <WebRoute><MvirsLoginScreen /></WebRoute>
          } />

          {/* Both logins required */}
          <Route path="/dashboard" element={
            <PrivateRoute><InspectionHistoryScreen /></PrivateRoute>
          } />

          <Route path='/inspection/customer' element={<PrivateRoute><CustomerDetailScreen /></PrivateRoute>} />
          <Route path='/inspection/vehicle' element={<PrivateRoute><CustomerDetailScreen /></PrivateRoute>} />
          <Route path='/inspection/insurance' element={<PrivateRoute><InsuranceDetailScreen /></PrivateRoute>} />
          <Route path='/inspection/:id' element={<PrivateRoute><InspectionDetailScreen /></PrivateRoute>} />

          {/* Default */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;